import React, { useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import { commonService } from "../../../utils/commonService";
const ChartDataAsTable = ({
    ChartData, ChartOption, id
}) => {
    const [title, setTitle] = useState("");
    const [header, setHeader] = useState([]);
    const [tbody, setTbody] = useState([]);

    useEffect(() => {
        let _title = "";
        let _header = [];
        let _tbody = [];


        if (ChartOption) {
            if (ChartOption.plugins) {
                if (ChartOption.plugins.title) {
                    if (ChartOption.plugins.title.text) {
                        _title = ChartOption.plugins.title.text;
                    }
                }
            }
        }
        if (ChartData) {
            if (ChartData.labels && ChartData.labels.length > 0) {
                _header.push("");
                ChartData.labels.map((l) => { _header.push(l) })
            }

            if (ChartData.datasets && ChartData.datasets.length > 0) {
                ChartData.datasets.map((data) => {
                    if (data.data && data.data.length > 0) {
                        let datarow = [];
                        let isdisplayintable = true;

                        if (data.isdisplayintable === false) {
                            isdisplayintable = false;
                        }

                        if (isdisplayintable) {
                            if (data.label) {
                                datarow.push(`<b>${data.label}</b>`);
                            }
                            else {
                                datarow.push("");
                            }
                            if (data.datatype === "amount") {
                                data.data.map((d) => { datarow.push(commonService.formateAmount(d ? d : 0)) })
                            }
                            else if (data.datatype === "candlestick with amount") {
                                data.data.map((d) => {
                                    datarow.push(`
                                        <p><b>H</b> : ${commonService.formateAmount(d.h ? d.h : 0)}</p><br/>
                                        <p><b>C</b> : ${commonService.formateAmount(d.c ? d.c : 0)}</p><br/>
                                        <p><b>O</b> : ${commonService.formateAmount(d.o ? d.o : 0)}</p><br/>
                                        <p><b>L</b> : ${commonService.formateAmount(d.l ? d.l : 0)}</p>
                                        `)
                                })
                            }
                            else if (data.datatype === "candlestick") {
                                data.data.map((d) => {
                                    datarow.push(`
                                                    <p><b>H</b> : ${d.h}</p><br/>
                                                    <p><b>C</b> : ${d.c}</p><br/>
                                                    <p><b>O</b> : ${d.o}</p><br/>
                                                    <p><b>L</b> : ${d.l}</p>
                                                `)
                                })
                            }
                            else {
                                data.data.map((d) => { datarow.push(d) })
                            }
                            _tbody.push(datarow);
                        }
                    }
                })
            }
        }

        setTitle(_title);
        setHeader(_header);
        setTbody(_tbody);
    }, [ChartData, ChartOption]);

    return (
        <>
            {
                header && tbody && header.length > 0 && tbody.length > 0 &&
                <div className="ViewPropertySetupTable TableGraphDataContainerTable">
                    <div className="stripped__table">
                        <Table id={id} responsive>
                            <thead>
                                {
                                    title &&
                                    <tr>
                                        <th className="text-center" colSpan={header.length}>{title}</th>
                                    </tr>
                                }
                                <tr>
                                    {
                                        header.map((h) => <th>{h}</th>)
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    tbody.map((data) => {
                                        return (
                                            <tr>
                                                {
                                                    data.map((d) => {
                                                        return (
                                                            <td dangerouslySetInnerHTML={{ __html: d }}></td>
                                                        )
                                                    })
                                                }
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </Table>
                    </div>
                </div>
            }

        </>
    );
};

export default ChartDataAsTable;
